import { loadBlocks } from "./Blocks";
import { loadCommands } from "./Commands";
import { loadComponents } from "./Componenets";
import { loadEditorConfig } from "./EditorConfig";
import { loadStyling } from "./Style";

export const gjsPlugin = (editor: any, options: any) => 
{
	loadCommands(editor);
	loadEditorConfig(editor);
	loadStyling(editor);
	loadComponents(editor);
	loadBlocks(editor);
};